import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    overlay: 'fixed inset-0 z-[11000] bg-black/50',
    contentContainer:
      'group/drawer fixed right-0 bottom-0 left-0 z-[11000] flex max-h-[calc(var(--viewport-height)_-_20px)] flex-col outline-none sm:inset-y-0 sm:mt-0 sm:max-h-none',
    content:
      'relative w-full flex-1 overflow-y-auto bg-white max-md:px-3 max-md:py-6 sm:w-[680px] sm:px-16 sm:py-16',
    closeButton:
      'text-icon-main top-px-16 right-px-16 absolute hidden size-10 p-2 group-data-[state=closed]/drawer:cursor-default max-md:top-4 max-md:right-1 max-md:flex md:top-5 md:right-5 md:flex',
    closeIcon: 'hover:[&>path]:stroke-brand-primary size-7 sm:size-10',
    divider:
      'absolute -top-4 left-1/2 h-1.5 w-13 -translate-x-1/2 rounded-full transition-opacity duration-300 group-data-[state=closed]/drawer:opacity-0 sm:hidden'
  },
  variants: {
    direction: {
      left: {
        contentContainer: 'sm:inset-y-0 sm:right-auto sm:left-0'
      },
      right: {
        contentContainer: 'sm:inset-y-0 sm:right-0 sm:left-auto'
      },
      bottom: {
        contentContainer:
          'sm:inset-x-0 sm:top-auto sm:bottom-0 sm:max-h-[calc(var(--viewport-height)_-_20px)] sm:w-full',
        content: 'sm:w-full sm:px-4 sm:py-8',
        closeButton: 'sm:hidden',
        divider: 'sm:block'
      }
    },
    position: {
      center: {
        content: 'flex flex-col pt-[40px] lg:justify-center lg:pt-0'
      }
    },
    withoutMobile: {
      true: {
        contentContainer: 'top-0 max-h-[100dvh]',
        content: 'min-h-0 py-12 lg:justify-start',
        divider: 'hidden',
        closeButton: 'flex'
      }
    }
  }
});
